export var investmentGrowthDecumation = [
    {
      "name": "2020",
      "series": [
        {
          "name": "Investment Value, Pre Retirement",
          "value": 100000
        }
      ]
    }, 
    {
      "name": "2021",
      "series": [
        {
          "name": "Investment Value, Pre Retirement",
          "value": 110000
        }
      ]
    },
    {
        "name": "2022",
        "series": [
          {
            "name": "Investment Value, Pre Retirement",
            "value": 120000
          }
        ]
      },
      {
        "name": "2022",
        "series": [
          {
            "name": "Investment Value, Pre Retirement",
            "value": 130000
          }
        ]
      },
      {
        "name": "2023",
        "series": [
          {
            "name": "Investment Value, Pre Retirement",
            "value": 140000
          }
        ]
      },
      {
        "name": "2024",
        "series": [
          {
            "name": "Investment Value, Pre Retirement",
            "value": 150000
          }
        ]
      },
      {
        "name": "2025",
        "series": [
          {
            "name": "Investment Value, Pre Retirement",
            "value": 160000
          }
        ]
      },
      {
        "name": "2026",
        "series": [
          {
            "name": "Investment Value, Pre Retirement",
            "value": 170000
          }
        ]
      },
      {
        "name": "2027",
        "series": [
          {
            "name": "Investment Value, Pre Retirement",
            "value": 180000
          }
        ]
      },
      {
        "name": "2028",
        "series": [
          {
            "name": "Investment Value, Pre Retirement",
            "value": 190000
          }
        ]
      },
      {
        "name": "2029",
        "series": [
          {
            "name": "Investment Value, Pre Retirement",
            "value": 200000
          }
        ]
      },
      {
        "name": "2030",
        "series": [
            {
                "name": "Annual Healthcare Spend",
                "value": 20000
            },
          {
            "name": "Investment Value, In Retirement",
            "value": 190000
          },
        ]
      },
      {
        "name": "2031",
        "series": [
            {
                "name": "Annual Healthcare Spend",
                "value": 20000
              },
          {
            "name": "Investment Value, In Retirement",
            "value": 200000
          },
        ]
      },
      {
        "name": "2032",
        "series": [
            {
                "name": "Annual Healthcare Spend",
                "value": 30000
              },
          {
            "name": "Investment Value, In Retirement",
            "value": 200000
          },

        ]
      },
      {
        "name": "2033",
        "series": [
            {
                "name": "Annual Healthcare Spend",
                "value": 40000
              },
          {
            "name": "Investment Value, In Retirement",
            "value": 200000
          },

        ]
      },
      {
        "name": "2034",
        "series": [
            {
                "name": "Annual Healthcare Spend",
                "value": 60000
              },
          {
            "name": "Investment Value, In Retirement",
            "value": 190000
          },

        ]
      },
      {
        "name": "2035",
        "series": [
            {
                "name": "Annual Healthcare Spend",
                "value": 65000
              },
          {
            "name": "Investment Value, In Retirement",
            "value": 190000
          },

        ]
      },
      {
        "name": "2036",
        "series": [
            {
                "name": "Annual Healthcare Spend",
                "value": 70000
              },
          {
            "name": "Investment Value, In Retirement",
            "value": 190000
          },

        ]
      },
      {
        "name": "2037",
        "series": [
            {
                "name": "Annual Healthcare Spend",
                "value": 85000
              },
          {
            "name": "Investment Value, In Retirement",
            "value": 180000
          },

        ]
      },
      {
        "name": "2038",
        "series": [
            {
                "name": "Annual Healthcare Spend",
                "value": 90000
              },
          {
            "name": "Investment Value, In Retirement",
            "value": 170000
          },

        ]
      },
      {
        "name": "2039",
        "series": [
            {
                "name": "Annual Healthcare Spend",
                "value": 85000
              },
          {
            "name": "Investment Value, In Retirement",
            "value": 165000
          },

        ]
      },
      {
        "name": "2040",
        "series": [
            {
                "name": "Annual Healthcare Spend",
                "value": 80000
              },
          {
            "name": "Investment Value, In Retirement",
            "value": 160000
          },

        ]
      },
      {
        "name": "2041",
        "series": [
            {
                "name": "Annual Healthcare Spend",
                "value": 70000
              },
          {
            "name": "Investment Value, In Retirement",
            "value": 165000
          },

        ]
      },
      {
        "name": "2042",
        "series": [
            {
                "name": "Annual Healthcare Spend",
                "value": 60000
              },
          {
            "name": "Investment Value, In Retirement",
            "value": 160000
          },

        ]
      },
      {
        "name": "2043",
        "series": [
            {
                "name": "Annual Healthcare Spend",
                "value": 55000
              },
          {
            "name": "Investment Value, In Retirement",
            "value": 155000
          },

        ]
      },
      {
        "name": "2044",
        "series": [
            {
                "name": "Annual Healthcare Spend",
                "value": 50000
              },
          {
            "name": "Investment Value, In Retirement",
            "value": 150000
          },

        ]
      },
      {
        "name": "2045",
        "series": [
            {
                "name": "Annual Healthcare Spend",
                "value": 45000
              },
          {
            "name": "Investment Value, In Retirement",
            "value": 150000
          },

        ]
      },
      {
        "name": "2046",
        "series": [
            {
                "name": "Annual Healthcare Spend",
                "value": 30000
              },
          {
            "name": "Investment Value, In Retirement",
            "value": 155000
          },

        ]
      },
      {
        "name": "2047",
        "series": [
            {
                "name": "Annual Healthcare Spend",
                "value": 30000
              },
          {
            "name": "Investment Value, In Retirement",
            "value": 150000
          },

        ]
      },
      {
        "name": "2048",
        "series": [
            {
                "name": "Annual Healthcare Spend",
                "value": 30000
              },
          {
            "name": "Investment Value, In Retirement",
            "value": 140000
          },

        ]
      },
      {
        "name": "2049",
        "series": [
            {
                "name": "Annual Healthcare Spend",
                "value": 35000
              },
          {
            "name": "Investment Value, In Retirement",
            "value": 125000
          },

        ]
      },
      {
        "name": "2050",
        "series": [
            {
                "name": "Annual Healthcare Spend",
                "value": 30000
              },
          {
            "name": "Investment Value, In Retirement",
            "value": 120000
          },

        ]
      },
      {
        "name": "2051",
        "series": [
            {
                "name": "Annual Healthcare Spend",
                "value": 25000
              },
          {
            "name": "Investment Value, In Retirement",
            "value": 110000
          },

        ]
      },
      {
        "name": "2052",
        "series": [
            {
                "name": "Annual Healthcare Spend",
                "value": 25000
              },
          {
            "name": "Investment Value, In Retirement",
            "value": 100000
          },

        ]
      },
      {
        "name": "2053",
        "series": [
            {
                "name": "Annual Healthcare Spend",
                "value": 20000
              },
          {
            "name": "Investment Value, In Retirement",
            "value":90000
          },

        ]
      },
      {
        "name": "2054",
        "series": [
            {
                "name": "Annual Healthcare Spend",
                "value": 20000
              },
          {
            "name": "Investment Value, In Retirement",
            "value": 80000
          },

        ]
      },
      {
        "name": "2055",
        "series": [
            {
                "name": "Annual Healthcare Spend",
                "value": 20000
              },
          {
            "name": "Investment Value, In Retirement",
            "value": 70000
          },

        ]
      },
      {
        "name": "2056",
        "series": [
            {
                "name": "Annual Healthcare Spend",
                "value": 20000
              },
          {
            "name": "Investment Value, In Retirement",
            "value": 60000
          },

        ]
      },
      {
        "name": "2057",
        "series": [
            {
                "name": "Annual Healthcare Spend",
                "value": 30000
              },
          {
            "name": "Investment Value, In Retirement",
            "value": 40000
          },

        ]
      },
      {
        "name": "2057",
        "series": [
            {
                "name": "Annual Healthcare Spend",
                "value": 30000
              },
          {
            "name": "Investment Value, In Retirement",
            "value": 30000
          },

        ]
      },
      {
        "name": "2058",
        "series": [
            {
                "name": "Annual Healthcare Spend",
                "value": 30000
              },
          {
            "name": "Investment Value, In Retirement",
            "value": 20000
          },

        ]
      },
      {
        "name": "2057",
        "series": [
            {
                "name": "Annual Healthcare Spend",
                "value": 25000
              },
          {
            "name": "Investment Value, In Retirement",
            "value": 10000
          },

        ]
      },
  
    // {
    //   "name": "2022",
    //   "series": [
    //     {
    //       "name": "2010",
    //       "value": 5000002
    //     },
    //     {
    //       "name": "2011",
    //       "value": 5800000
    //     }
    //   ]
    // }
  ];